module.exports = __webpack_public_path__ + "static/media/mobile11.a5f3326e.png";